<template>
  <div class="Eliminar">
    <div class="Cuenta">
      <div>Eliminar Cuenta</div>
      <img src="@/assets/imgs/img27.png" class="img27" />
    </div>
    <div class="Estimado">Estimado cliente</div>
    <div class="Estimado-desc">
      <div>
        Si experimenta algún inconveniente o tiene alguna duda, puede
        contactarnos en cualquier momento a través de nuestro correo
        electrónico:
        <span style="color: #fe953a">servicio@previcremsofom.mx</span>. Nuestro equipo
        trabajará diligentemente para resolver su problema lo antes posible.
        Estamos aquí para ayudarle y le pedimos que nos dé una oportunidad de
        solucionar cualquier inconveniente que pueda tener.
      </div>
      <div>
        Si, después de esto, aún desea proceder con la eliminación de sus datos,
        le solicitamos que ingrese el número de teléfono asociado a su cuenta de
        la aplicación a continuación y haga clic en "Enviar". Procesaremos su
        solicitud en un plazo de 3 a 5 días hábiles.
      </div>
      <div>
        ¡Gracias por su comprensión y paciencia! Estamos comprometidos con su
        satisfacción y seguridad.
      </div>
    </div>
    <div class="Teono">Teléfono</div>
    <div class="phone">
      <div class="phone-box">
        <div class="qianzhui">+52</div>
        <input
          class="phone-input"
          type="number"
          v-model="phone"
          oninput="if(value.length>10)value=value.slice(0,10)"
          placeholder="Por favor, ingrese el número de teléfono celular del que desea eliminar los datos."
        />
      </div>
      <div
        class="Enviar"
        :style="phone.length === 10 ? 'opacity: 1;' : ''"
        @click="Confirmar"
      >
        Enviar
      </div>
    </div>

    <transition name="slide-fade" @after-enter="hideElement">
      <div class="success" v-if="showSuccess">
        <div>
          <div>Eliminado con éxito</div>
          <div>esperamos verlo pronto!</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Eliminar',
  components: {},
  data() {
    return {
      phone: '',
      showSuccess: false,
    };
  },
  methods: {
    Confirmar() {
      if (this.phone.length === 10) {
        this.showSuccess = true;
        this.phone = '';
      }
    },
    hideElement() {
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.Cuenta {
  margin-top: 100px;
  height: 331px;
  background-image: url('@/assets/imgs/img26.png');
  background-size: 100% 100%;
  text-align: center;
  font-weight: bold;
  font-size: 50px;
  color: #000000;
}
.img27 {
  margin-top: 70px;
  width: 317px;
  height: 287px;
}
.Estimado {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  text-align: center;
  margin-top: 180px;
}
.Estimado-desc {
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  padding: 0 360px;
  text-align: center;
  margin-bottom: 100px;
}
.Teono {
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
  text-align: center;
}
.phone {
  padding: 0 360px;
  margin-bottom: 140px;
}
.phone-box {
  height: 66px;
  border-radius: 16px;
  border: 2px dashed #d6d6d6;
  padding: 12px 0;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 45px;
}
.qianzhui {
  width: 80px;
  font-size: 16px;
  color: #000000;
  border-right: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 26px;
}
.phone-input {
  margin-left: 10px;
  font-size: 16px;
  color: #565656;
  border: none;
  outline: none;
  flex: 1;
}
/* 隐藏输入框上下箭头 */
.phone-input::-webkit-inner-spin-button,
.phone-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 兼容Firefox */
.phone-input[type='number'] {
  -moz-appearance: textfield;
}

.Enviar {
  width: 464px;
  height: 64px;
  background: linear-gradient(336deg, #ff8630 0%, #fca948 100%);
  box-shadow: 0px 2px 13px 0px rgba(255, 134, 48, 0.75);
  border-radius: 43px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 64px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
  opacity: 0.5;
}

.slide-fade-enter-active {
  transition: opacity 1s;
}
.slide-fade-enter {
  opacity: 0;
}

.success {
  width: 320px;
  height: 64px;
  background: #ffffff;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}
.success img {
  width: 48px;
  height: 44px;
  margin-right: 20px;
}

.success div div:first-child {
  font-weight: 500;
  font-size: 14px;
  color: #787878;
  margin-bottom: 5px;
}
.success div div:last-child {
  font-weight: 500;
  font-size: 18px;
  color: #fa7e32;
}
</style>
